module.exports = __webpack_public_path__ + "8877af342c05d9d3b9f18021d16efe90.pdf";